// imove-behavior: 初始化完成通知

export default async function(ctx) {
  const { webReport = {} } = ctx.getPipe() || {};
  ctx.emit('reportLoad', webReport)
  return webReport;
}